import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { userMenuMapping } = stateEnum

const initialState = {  
  selectedUserMenu: {},
}

const userMenuMappingSlice = createSlice({
  name: userMenuMapping,
  initialState,
  reducers: {
    resetAppClientMapping: (state) => { 
      state.selectedUserMenu = {}
    },
    setSelectedUserMenu: (state, action) => {
      state.selectedUserMenu = action.payload
    }, 
  }, 
}) 
export const { 
  resetAppClientMapping, 
  setSelectedUserMenu, 
} = userMenuMappingSlice.actions

export default userMenuMappingSlice.reducer
